var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 0.833008H8.33337C7.87314 0.833008 7.50004 1.2061 7.50004 1.66634V18.333C7.50004 18.7932 7.87314 19.1663 8.33337 19.1663H11.6667C12.1269 19.1663 12.5 18.7932 12.5 18.333V1.66634C12.5 1.2061 12.1269 0.833008 11.6667 0.833008ZM18.3334 7.49967H15C14.5398 7.49967 14.1667 7.87277 14.1667 8.33301V18.333C14.1667 18.7932 14.5398 19.1663 15 19.1663H18.3334C18.7936 19.1663 19.1667 18.7932 19.1667 18.333V8.33301C19.1667 7.87277 18.7936 7.49967 18.3334 7.49967ZM1.66671 10.833H5.00004C5.46028 10.833 5.83337 11.2061 5.83337 11.6663V18.333C5.83337 18.7932 5.46028 19.1663 5.00004 19.1663H1.66671C1.20647 19.1663 0.833374 18.7932 0.833374 18.333V11.6663C0.833374 11.2061 1.20647 10.833 1.66671 10.833ZM2.50004 17.4997H4.16671V12.4997H2.50004V17.4997ZM15.8334 17.4997H17.5V9.16634H15.8334V17.4997ZM9.16671 17.4997H10.8334V2.49967H9.16671V17.4997Z",
    fill: "#0024A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBar);
export default __webpack_public_path__ + "static/media/graph-bar.b06f0cacd49a0b5cb66ac2efca28420b.svg";
export { ForwardRef as ReactComponent };